<template>
	<div class="box">
		<div
			class="content-left"
			:class="dayNightMode == 'day' ? 'day-mode' : 'night-mode'"
			:style="{
				'border-left': `1px solid ${dayNightMode == 'day' ? '#000' : '#fff'}`,
			}"
		>
			<h1 class="sora-h1" :class="dayNightMode == 'day' ? 'day-mode' : 'night-mode'">CONTACT US</h1>
			<div
				class="content-details"
				:class="dayNightMode == 'day' ? 'day-mode' : 'night-mode'"
				v-for="item in contactUs"
				:key="item.id"
			>
				<h1 class="content-details-h1">{{ item.title }}</h1>
				<div class="content-details-text">
					<p :class="dayNightMode == 'day' ? 'day-mode' : 'night-mode'">Tel.</p>
					<p :class="dayNightMode == 'day' ? 'day-mode' : 'night-mode'">{{ item.tel }}</p>
				</div>

				<div class="content-details-text">
					<p :class="dayNightMode == 'day' ? 'day-mode' : 'night-mode'">Email.</p>
					<p :class="dayNightMode == 'day' ? 'day-mode' : 'night-mode'">{{ item.email }}</p>
				</div>

				<!-- Add. 403, 4TH FLOOR, TOWER 2, HUAMAO CENTRAL PLACE,
        HUICHENG DISTRICT, HUIZHOU, CHINA. -->
				<div class="content-details-text">
					<p :class="dayNightMode == 'day' ? 'day-mode' : 'night-mode'">Add.</p>
					<p
						class="content-details-text-add"
						:class="dayNightMode == 'day' ? 'day-mode' : 'night-mode'"
						>{{ item.address_en }}</p
					>
				</div>

				<p class="content-details-p" :class="dayNightMode == 'day' ? 'day-mode' : 'night-mode'">{{
					item.address_cn
				}}</p>

				<div class="content-details-img"><img :src="item.img" alt=""/></div>
			</div>
		</div>
		<div
			class="content-right"
			:class="dayNightMode == 'day' ? 'day-mode' : 'night-mode'"
			:style="{
				'border-left': `1px solid ${dayNightMode == 'day' ? '#000' : '#fff'}`,
			}"
		>
			<h1 class="sora-h1" :class="dayNightMode == 'day' ? 'day-mode' : 'night-mode'">JOBS</h1>
			<h1 class="content-details-h1 content-details-h1-c">WELCOME JOIN SORA</h1>
			<ul class="content-right-ul">
				<li v-for="(item, index) in jobsData.title_cn" :key="index">
					<p>{{ item }}</p>
					<p>{{ jobsData.title_en[index] }}</p>
				</li>
			</ul>
			<div class="content-right-email">
				<p :class="dayNightMode == 'day' ? 'day-mode' : 'night-mode'">请将个人简历及作品发送至:</p>
				<p :class="dayNightMode == 'day' ? 'day-mode' : 'night-mode'">{{ jobsData.email }}</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				contactUs: '', //关于我们
				jobsData: '', //邮箱

				dayNightMode: this.$store.state.dayNightMode,
			};
		},
		created() {
			this.getContactData();
		},
		watch: {
			'$store.state.dayNightMode': function() {
				this.dayNightMode = this.$store.state.dayNightMode;
			},
		},
		mounted() {},
		methods: {
			// 获取contact us数据
			getContactData() {
				this.$post('api/contact/getContact').then((res) => {
					this.contactUs = res.data;
				});

				this.$post('api/contact/getJobs').then((res) => {
					this.jobsData = res.data;
				});
			},
		},
	};
</script>

<style lang="less" scoped>
	@font-face {
		font-family: nexalight;
		src: url(../../public/font/NexaLight.otf);
	}
	@font-face {
		font-family: nexaBold;
		src: url(../../public/font/NexaBold.otf);
	}
	@font-face {
		font-family: SourceHanSansNormal;
		src: url(../../public/font/SourceHanSansCN-Normal.otf);
	}

	.content-details-text-add {
		width: 94%;
		word-wrap: break-word;
		// text-align: justify;
		line-height: 28px;
	}

	.content-left,
	.content-right {
		width: 50%;
		float: left;
		padding: 0.1823rem 0.1563rem 0 0.2083rem;
		border-left: 1px solid #000;
		height: 100vh;
		overflow: auto;
		background: #dbdcdc;
	}

	.content-left::-webkit-scrollbar {
		width: 0px;
	}
	.content-right::-webkit-scrollbar {
		width: 0px;
	}

	.content-details {
		margin-bottom: 0.1979rem;
	}

	.content-details .content-details-text:nth-child(4) {
		margin-bottom: 0.0365rem;
	}

	.content-details-h1 {
		font-size: 0.1667rem;
		margin: 0.0729rem 0;
		font-family: nexaBold;
	}

	.content-details-h1-c {
		margin-bottom: 0.125rem;
	}

	.content-details-text {
		margin-bottom: 0.0625rem;
		display: flex;
		p {
			font-size: 0.1146rem;
			color: #231815;
			font-family: nexalight;
		}
		p:first-child {
			margin-right: 0.0417rem;
			// width: 60px;
		}
	}

	.content-details-p {
		font-size: 0.125rem;
		color: #231815;
	}

	.content-details-img {
		width: 100%;
		height: 1.9896rem;
		overflow: hidden;
		margin-top: 0.1094rem;
		img {
			height: 110%;
		}
	}

	.content-right-ul {
		padding: 0.1302rem 0;
		border-top: 1px solid #6e6e6e;
		border-bottom: 1px solid #6e6e6e;
		margin-bottom: 0.1354rem;
		li {
			display: flex;
			justify-content: space-between;
			margin-bottom: 0.0781rem;
			font-family: nexalight;
			p:first-child {
				font-size: 0.125rem;
				font-family: SourceHanSansNormal;
			}
			p:last-child {
				font-size: 0.1146rem;
				font-family: nexalight;
			}
		}
		li:last-child {
			margin-bottom: 0;
		}
	}

	.content-right-email {
		p {
			color: #231815;
		}
		p:first-child {
			font-size: 0.125rem;
			margin-bottom: 0.0938rem;
		}
		p:last-child {
			font-size: 0.1146rem;
			font-family: nexalight;
		}
	}
</style>
